import { AppLanguage } from "../context/LanguageContext";

type TranslationMap = Record<string, Partial<Record<AppLanguage, string>>>;

const phraseTranslations: TranslationMap = {
  Menu: { "pt-BR": "Menu", es: "Menu" },
  Others: { "pt-BR": "Outros", es: "Otros" },
  Dashboard: { "pt-BR": "Painel", es: "Panel" },
  Ecommerce: { "pt-BR": "Comércio", es: "Comercio" },
  Calendar: { "pt-BR": "Calendário", es: "Calendario" },
  Forms: { "pt-BR": "Formulários", es: "Formularios" },
  "Form Elements": { "pt-BR": "Elementos de formulário", es: "Elementos de formulario" },
  Tables: { "pt-BR": "Tabelas", es: "Tablas" },
  "Basic Tables": { "pt-BR": "Tabelas básicas", es: "Tablas básicas" },
  Pages: { "pt-BR": "Páginas", es: "Páginas" },
  "404 Error": { "pt-BR": "Erro 404", es: "Error 404" },
  "Blank Page": { "pt-BR": "Página em branco", es: "Página en blanco" },
  Charts: { "pt-BR": "Gráficos", es: "Gráficos" },
  "Line Chart": { "pt-BR": "Gráfico de linha", es: "Gráfico de línea" },
  "Bar Chart": { "pt-BR": "Gráfico de barras", es: "Gráfico de barras" },
  "UI Elements": { "pt-BR": "Elementos de interface", es: "Elementos de interfaz" },
  Alerts: { "pt-BR": "Alertas", es: "Alertas" },
  Avatar: { "pt-BR": "Avatar", es: "Avatar" },
  Badge: { "pt-BR": "Selo", es: "Insignia" },
  Buttons: { "pt-BR": "Botões", es: "Botones" },
  Images: { "pt-BR": "Imagens", es: "Imagenes" },
  Videos: { "pt-BR": "Vídeos", es: "Vídeos" },
  Authentication: { "pt-BR": "Autenticação", es: "Autenticación" },
  "Sign In": { "pt-BR": "Entrar", es: "Iniciar sesion" },
  "Sign in": { "pt-BR": "Entrar", es: "Iniciar sesion" },
  "Sign Up": { "pt-BR": "Cadastrar", es: "Registrarse" },
  "Sign up": { "pt-BR": "Cadastrar", es: "Registrarse" },
  "Edit profile": { "pt-BR": "Editar perfil", es: "Editar perfil" },
  "Account settings": { "pt-BR": "Configurações da conta", es: "Configuración de la cuenta" },
  Support: { "pt-BR": "Suporte", es: "Soporte" },
  "Sign out": { "pt-BR": "Sair", es: "Cerrar sesion" },
  Language: { "pt-BR": "Linguagem", es: "Idioma" },
  "Portuguese (Brazil)": { "pt-BR": "Português (Brasil)", es: "Portugués (Brasil)" },
  Spanish: { "pt-BR": "Espanhol", es: "Espanol" },
  English: { "pt-BR": "Inglês", es: "Inglés" },
  "Back to dashboard": { "pt-BR": "Voltar ao painel", es: "Volver al panel" },
  "Forgot password?": { "pt-BR": "Esqueceu a senha?", es: "Olvidaste la contrasena?" },
  "Keep me logged in": { "pt-BR": "Manter conectado", es: "Mantener sesión iniciada" },
  "Search or type command...": {
    "pt-BR": "Pesquisar ou digitar comando...",
    es: "Buscar o escribir comando...",
  },
  Statistics: { "pt-BR": "Estatísticas", es: "Estadísticas" },
  "Monthly Target": { "pt-BR": "Meta Mensal", es: "Objetivo Mensual" },
  "Monthly Sales": { "pt-BR": "Vendas Mensais", es: "Ventas Mensuales" },
  "Target you've set for each month": {
    "pt-BR": "Meta definida para cada mês",
    es: "Objetivo definido para cada mes",
  },
  "You earn $3287 today, it's higher than last month. Keep up your good work!": {
    "pt-BR": "Você ganhou $3287 hoje, valor maior que no mês passado. Continue com o ótimo trabalho!",
    es: "Ganaste $3287 hoy, es más que el mes pasado. ¡Sigue con el gran trabajo!",
  },
  Target: { "pt-BR": "Meta", es: "Objetivo" },
  Revenue: { "pt-BR": "Receita", es: "Ingresos" },
  Today: { "pt-BR": "Hoje", es: "Hoy" },
  Monthly: { "pt-BR": "Mensal", es: "Mensual" },
  Quarterly: { "pt-BR": "Trimestral", es: "Trimestral" },
  Annually: { "pt-BR": "Anual", es: "Anual" },
  Products: { "pt-BR": "Produtos", es: "Productos" },
  Product: { "pt-BR": "Produto", es: "Producto" },
  Category: { "pt-BR": "Categoria", es: "Categoría" },
  Price: { "pt-BR": "Preço", es: "Precio" },
  Address: { "pt-BR": "Endereço", es: "Dirección" },
  "Edit Address": { "pt-BR": "Editar endereço", es: "Editar dirección" },
  "Email Address": { "pt-BR": "Endereço de e-mail", es: "Dirección de correo" },
  Profile: { "pt-BR": "Perfil", es: "Perfil" },
  "Personal Information": { "pt-BR": "Informações pessoais", es: "Información personal" },
  "Edit Personal Information": {
    "pt-BR": "Editar informações pessoais",
    es: "Editar información personal",
  },
  "Update your details to keep your profile up-to-date.": {
    "pt-BR": "Atualize seus dados para manter seu perfil em dia.",
    es: "Actualiza tus datos para mantener tu perfil al día.",
  },
  "First Name": { "pt-BR": "Nome", es: "Nombre" },
  "Last Name": { "pt-BR": "Sobrenome", es: "Apellido" },
  Phone: { "pt-BR": "Telefone", es: "Teléfono" },
  Bio: { "pt-BR": "Bio", es: "Biografía" },
  Country: { "pt-BR": "País", es: "País" },
  "City/State": { "pt-BR": "Cidade/Estado", es: "Ciudad/Estado" },
  "Postal Code": { "pt-BR": "CEP", es: "Código postal" },
  "TAX ID": { "pt-BR": "CPF/CNPJ", es: "NIF" },
  Edit: { "pt-BR": "Editar", es: "Editar" },
  Close: { "pt-BR": "Fechar", es: "Cerrar" },
  "Save Changes": { "pt-BR": "Salvar alterações", es: "Guardar cambios" },
  "View More": { "pt-BR": "Ver mais", es: "Ver más" },
  Delete: { "pt-BR": "Excluir", es: "Eliminar" },
  Jan: { "pt-BR": "Jan", es: "Ene" },
  Feb: { "pt-BR": "Fev", es: "Feb" },
  Mar: { "pt-BR": "Mar", es: "Mar" },
  Apr: { "pt-BR": "Abr", es: "Abr" },
  May: { "pt-BR": "Mai", es: "May" },
  Jun: { "pt-BR": "Jun", es: "Jun" },
  Jul: { "pt-BR": "Jul", es: "Jul" },
  Aug: { "pt-BR": "Ago", es: "Ago" },
  Sep: { "pt-BR": "Set", es: "Sep" },
  Oct: { "pt-BR": "Out", es: "Oct" },
  Nov: { "pt-BR": "Nov", es: "Nov" },
  Dec: { "pt-BR": "Dez", es: "Dic" },
  "You can now view tailadmin-react-free in the browser.": {
    "pt-BR": "Agora você pode visualizar tailadmin-react-free no navegador.",
    es: "Ahora puedes ver tailadmin-react-free en el navegador.",
  },
  Customers: { "pt-BR": "Clientes", es: "Clientes" },
  Orders: { "pt-BR": "Pedidos", es: "Pedidos" },
  "Recent Orders": { "pt-BR": "Pedidos recentes", es: "Pedidos recientes" },
  "Customers Demographic": {
    "pt-BR": "Demografia de clientes",
    es: "Demografia de clientes",
  },
  "Number of customer based on country": {
    "pt-BR": "Numero de clientes por pais",
    es: "Numero de clientes por pais",
  },
  Filter: { "pt-BR": "Filtrar", es: "Filtrar" },
  "See all": { "pt-BR": "Ver todos", es: "Ver todo" },
  Status: { "pt-BR": "Status", es: "Estado" },
  Home: { "pt-BR": "Inicio", es: "Inicio" },
  "Back to Home Page": {
    "pt-BR": "Voltar para a pagina inicial",
    es: "Volver a la pagina de inicio",
  },
  "We can't seem to find the page you are looking for!": {
    "pt-BR": "Nao conseguimos encontrar a pagina que voce esta procurando!",
    es: "No podemos encontrar la pagina que estas buscando!",
  },
  "We can’t seem to find the page you are looking for!": {
    "pt-BR": "Nao conseguimos encontrar a pagina que voce esta procurando!",
    es: "No podemos encontrar la pagina que estas buscando!",
  },
  "Add Event +": { "pt-BR": "Adicionar evento +", es: "Agregar evento +" },
  "Add Event": { "pt-BR": "Adicionar evento", es: "Agregar evento" },
  "Edit Event": { "pt-BR": "Editar evento", es: "Editar evento" },
  "Event Title": { "pt-BR": "Titulo do evento", es: "Titulo del evento" },
  "Event Color": { "pt-BR": "Cor do evento", es: "Color del evento" },
  "Enter Start Date": {
    "pt-BR": "Informe a data de inicio",
    es: "Ingresa la fecha de inicio",
  },
  "Enter End Date": {
    "pt-BR": "Informe a data de fim",
    es: "Ingresa la fecha de fin",
  },
  "Plan your next big moment: schedule or edit an event to stay on track": {
    "pt-BR": "Planeje seu proximo grande momento: agende ou edite um evento para manter tudo no caminho",
    es: "Planifica tu proximo gran momento: agenda o edita un evento para mantenerte al dia",
  },
  "Update Changes": { "pt-BR": "Atualizar alteracoes", es: "Actualizar cambios" },
  "Basic Table 1": { "pt-BR": "Tabela basica 1", es: "Tabla basica 1" },
  User: { "pt-BR": "Usuario", es: "Usuario" },
  "Project Name": { "pt-BR": "Nome do projeto", es: "Nombre del proyecto" },
  Team: { "pt-BR": "Equipe", es: "Equipo" },
  Budget: { "pt-BR": "Orcamento", es: "Presupuesto" },
  "Sign in with Google": {
    "pt-BR": "Entrar com Google",
    es: "Iniciar sesion con Google",
  },
  "Sign in with X": { "pt-BR": "Entrar com X", es: "Iniciar sesion con X" },
  "Sign up with Google": {
    "pt-BR": "Cadastrar com Google",
    es: "Registrarse con Google",
  },
  "Sign up with X": { "pt-BR": "Cadastrar com X", es: "Registrarse con X" },
  "Enter your email and password to sign in!": {
    "pt-BR": "Digite seu e-mail e senha para entrar!",
    es: "Ingresa tu correo y contrasena para iniciar sesion!",
  },
  "Enter your email and password to sign up!": {
    "pt-BR": "Digite seu e-mail e senha para se cadastrar!",
    es: "Ingresa tu correo y contrasena para registrarte!",
  },
  "Enter your email to sign up!": {
    "pt-BR": "Digite seu e-mail para se cadastrar!",
    es: "Ingresa tu correo para registrarte!",
  },
  "Don't have an account?": {
    "pt-BR": "Nao tem uma conta?",
    es: "No tienes una cuenta?",
  },
  "Already have an account?": {
    "pt-BR": "Ja tem uma conta?",
    es: "Ya tienes una cuenta?",
  },
  "By creating an account means you agree to the": {
    "pt-BR": "Ao criar uma conta, você concorda com os",
    es: "Al crear una cuenta, aceptas los",
  },
  "and our": { "pt-BR": "e nossa", es: "y nuestra" },
  "Terms and Conditions,": { "pt-BR": "Termos e Condições,", es: "Terminos y Condiciones," },
  "Privacy Policy": { "pt-BR": "Política de Privacidade", es: "Politica de Privacidad" },
  "From Elements": { "pt-BR": "Elementos de formulario", es: "Elementos de formulario" },
  "Event Conf.": { "pt-BR": "Conf. de evento", es: "Conf. de evento" },
};

const wordTranslations: Record<
  Exclude<AppLanguage, "en">,
  Record<string, string>
> = {
  "pt-BR": {
    account: "conta",
    active: "ativo",
    add: "adicionar",
    address: "endereço",
    all: "todos",
    and: "e",
    apply: "aplicar",
    avatar: "avatar",
    back: "voltar",
    badge: "selo",
    bar: "barras",
    basic: "básico",
    button: "botão",
    buttons: "botões",
    calendar: "calendário",
    cancel: "cancelar",
    chart: "gráfico",
    charts: "gráficos",
    close: "fechar",
    color: "cor",
    command: "comando",
    create: "criar",
    dark: "escuro",
    dashboard: "painel",
    date: "data",
    default: "padrão",
    delete: "excluir",
    details: "detalhes",
    edit: "editar",
    email: "email",
    elements: "elementos",
    english: "ingles",
    error: "erro",
    export: "exportar",
    file: "arquivo",
    form: "formulário",
    forms: "formulários",
    grid: "grade",
    help: "ajuda",
    image: "imagem",
    images: "imagens",
    info: "informação",
    language: "linguagem",
    line: "linha",
    list: "lista",
    login: "entrar",
    logout: "sair",
    menu: "menu",
    modal: "modal",
    month: "mês",
    new: "novo",
    notification: "notificação",
    options: "opções",
    page: "página",
    pages: "páginas",
    password: "senha",
    pending: "pendente",
    personal: "pessoal",
    profile: "perfil",
    information: "informações",
    save: "salvar",
    search: "pesquisar",
    settings: "configurações",
    sign: "entrar",
    signin: "entrar",
    signup: "cadastrar",
    spanish: "espanhol",
    submit: "enviar",
    success: "sucesso",
    support: "suporte",
    table: "tabela",
    tables: "tabelas",
    task: "tarefa",
    theme: "tema",
    title: "título",
    first: "primeiro",
    last: "último",
    phone: "telefone",
    country: "país",
    city: "cidade",
    state: "estado",
    postal: "postal",
    code: "código",
    tax: "fiscal",
    changes: "alterações",
    today: "hoje",
    total: "total",
    update: "atualizar",
    user: "usuário",
    users: "usuários",
    video: "vídeo",
    videos: "vídeos",
    category: "categoria",
    categories: "categorias",
    product: "produto",
    products: "produtos",
    price: "preço",
    revenue: "receita",
    monthly: "mensal",
    quarterly: "trimestral",
    annually: "anual",
    view: "visualizar",
    warning: "aviso",
    welcome: "bem-vindo",
    sales: "vendas",
    customer: "cliente",
    customers: "clientes",
    order: "pedido",
    orders: "pedidos",
    recent: "recentes",
    demographic: "demografia",
    number: "numero",
    based: "baseado",
    on: "em",
    of: "de",
    see: "ver",
    enter: "digite",
    your: "seu",
    forgot: "esqueceu",
    logged: "conectado",
    with: "com",
    our: "nossa",
    have: "tem",
    already: "ja",
    by: "ao",
    creating: "criando",
    means: "significa",
    agree: "concorda",
    terms: "termos",
    conditions: "condicoes",
    privacy: "privacidade",
    policy: "politica",
    remember: "lembrar",
    username: "usuario",
    confirm: "confirmar",
    subject: "assunto",
    message: "mensagem",
    messages: "mensagens",
    description: "descricao",
    select: "selecionar",
    option: "opcao",
    upload: "enviar",
    picker: "seletor",
    payment: "pagamento",
    card: "cartao",
    gender: "genero",
    birth: "nascimento",
    street: "rua",
    post: "postal",
    membership: "assinatura",
    project: "projeto",
    budget: "orcamento",
    role: "funcao",
    designer: "designer",
    manager: "gerente",
    writing: "escrita",
    digital: "digital",
    marketer: "marketing",
    developer: "desenvolvedor",
    canceled: "cancelado",
    delivered: "entregue",
    event: "evento",
    events: "eventos",
    start: "inicio",
    end: "fim",
    plan: "planeje",
    next: "proximo",
    big: "grande",
    moment: "momento",
    schedule: "agendar",
    stay: "manter",
    track: "caminho",
    home: "inicio",
    team: "equipe",
    workshop: "workshop",
    meeting: "reuniao",
    or: "ou",
    dont: "nao",
    google: "google",
    x: "x",
  },
  es: {
    account: "cuenta",
    active: "activo",
    add: "agregar",
    address: "dirección",
    all: "todos",
    and: "y",
    apply: "aplicar",
    avatar: "avatar",
    back: "volver",
    badge: "insignia",
    bar: "barras",
    basic: "básico",
    button: "botón",
    buttons: "botones",
    calendar: "calendario",
    cancel: "cancelar",
    chart: "gráfico",
    charts: "gráficos",
    close: "cerrar",
    color: "color",
    command: "comando",
    create: "crear",
    dark: "oscuro",
    dashboard: "panel",
    date: "fecha",
    default: "predeterminado",
    delete: "eliminar",
    details: "detalles",
    edit: "editar",
    email: "correo",
    elements: "elementos",
    english: "inglés",
    error: "error",
    export: "exportar",
    file: "archivo",
    form: "formulario",
    forms: "formularios",
    grid: "cuadricula",
    help: "ayuda",
    image: "imagen",
    images: "imágenes",
    info: "información",
    language: "idioma",
    line: "línea",
    list: "lista",
    login: "iniciar sesion",
    logout: "cerrar sesion",
    menu: "menu",
    modal: "modal",
    month: "mes",
    new: "nuevo",
    notification: "notificación",
    options: "opciones",
    page: "página",
    pages: "páginas",
    password: "contraseña",
    pending: "pendiente",
    personal: "personal",
    profile: "perfil",
    information: "información",
    save: "guardar",
    search: "buscar",
    settings: "configuración",
    sign: "iniciar",
    signin: "iniciar sesion",
    signup: "registrarse",
    spanish: "español",
    submit: "enviar",
    success: "exito",
    support: "soporte",
    table: "tabla",
    tables: "tablas",
    task: "tarea",
    theme: "tema",
    title: "título",
    first: "nombre",
    last: "apellido",
    phone: "teléfono",
    country: "país",
    city: "ciudad",
    state: "estado",
    postal: "postal",
    code: "código",
    tax: "impuesto",
    changes: "cambios",
    today: "hoy",
    total: "total",
    update: "actualizar",
    user: "usuario",
    users: "usuarios",
    video: "video",
    videos: "videos",
    view: "ver",
    warning: "aviso",
    welcome: "bienvenido",
    sales: "ventas",
    customer: "cliente",
    customers: "clientes",
    order: "pedido",
    orders: "pedidos",
    recent: "recientes",
    demographic: "demografia",
    number: "numero",
    based: "basado",
    on: "en",
    of: "de",
    see: "ver",
    enter: "ingresa",
    your: "tu",
    forgot: "olvidaste",
    logged: "conectado",
    with: "con",
    our: "nuestra",
    have: "tienes",
    already: "ya",
    by: "al",
    creating: "crear",
    means: "significa",
    agree: "aceptas",
    terms: "terminos",
    conditions: "condiciones",
    privacy: "privacidad",
    policy: "politica",
    remember: "recordarme",
    username: "usuario",
    confirm: "confirmar",
    subject: "asunto",
    message: "mensaje",
    messages: "mensajes",
    description: "descripcion",
    select: "seleccionar",
    option: "opcion",
    upload: "subir",
    picker: "selector",
    payment: "pago",
    card: "tarjeta",
    gender: "genero",
    birth: "nacimiento",
    street: "calle",
    post: "postal",
    membership: "membresia",
    project: "proyecto",
    budget: "presupuesto",
    role: "rol",
    designer: "disenador",
    manager: "gerente",
    writing: "escritura",
    digital: "digital",
    marketer: "marketing",
    developer: "desarrollador",
    canceled: "cancelado",
    delivered: "entregado",
    event: "evento",
    events: "eventos",
    start: "inicio",
    end: "fin",
    plan: "planifica",
    next: "proximo",
    big: "gran",
    moment: "momento",
    schedule: "agenda",
    stay: "mantente",
    track: "camino",
    home: "inicio",
    team: "equipo",
    workshop: "taller",
    meeting: "reunion",
    or: "o",
    dont: "no",
    google: "google",
    x: "x",
    category: "categoría",
    categories: "categorías",
    product: "producto",
    products: "productos",
    price: "precio",
    revenue: "ingresos",
    monthly: "mensual",
    quarterly: "trimestral",
    annually: "anual",
  },
};

function preserveCasing(sourceWord: string, translatedWord: string) {
  if (sourceWord.toUpperCase() === sourceWord) {
    return translatedWord.toUpperCase();
  }
  if (
    sourceWord[0] === sourceWord[0].toUpperCase() &&
    sourceWord.slice(1) === sourceWord.slice(1).toLowerCase()
  ) {
    return translatedWord.charAt(0).toUpperCase() + translatedWord.slice(1);
  }
  return translatedWord;
}

function translateByWords(text: string, language: Exclude<AppLanguage, "en">) {
  const words = wordTranslations[language];
  let totalWords = 0;
  let translatedWords = 0;

  const translatedText = text.replace(/\b([A-Za-z][A-Za-z-]*)\b/g, (full, word: string) => {
    totalWords += 1;
    const normalized = word.toLowerCase();
    const translated = words[normalized];
    if (!translated) return full;
    translatedWords += 1;
    return preserveCasing(word, translated);
  });

  if (totalWords >= 3 && translatedWords / totalWords < 0.6) {
    return text;
  }

  return translatedText;
}

export function translateText(text: string, language: AppLanguage) {
  if (language === "en") return text;

  const normalizedText = text.replaceAll("â€™", "'").replaceAll("’", "'");

  const exact =
    phraseTranslations[text]?.[language] ??
    phraseTranslations[normalizedText]?.[language];
  if (exact) return exact;

  return translateByWords(normalizedText, language);
}
